import { DEBUG } from 'app/auth/authRoles'
import { ReduxUser } from 'app/redux/ReduxInterfaces'
import sfOauthConfig from 'app/services/sfAuth/sfAuthConfig'
import { ConnectedMap } from './FormTypes'

export const getObjectsIdsFromConnectedMap = (connectedMap: ConnectedMap, mainConnectedObject: string): {
  connectedAccount: string
  connectedSurvey: string
  connectedOpportunity: string
  editedObjectId: string
  connectedResource: string
} => {
  let connectedAccount, connectedOpportunity, connectedResource, connectedSurvey, editedObjectId

  Object.values(connectedMap).forEach((obj) => {
    if (obj.objectType === 'Opportunity') {
      connectedOpportunity = obj.sfObject.Id
    }
    if (obj.objectType === 'Account') {
      connectedAccount = obj.sfObject.Id
    }
    if (obj.objectType === 'Resource__c') {
      connectedResource = obj.sfObject.Id
    }
    if (obj.objectType === 'Survey__c') {
      connectedSurvey = obj.sfObject.Id
    }
    if (obj.objectType === mainConnectedObject) {
      editedObjectId = obj.sfObject.Id
    }
  })
  return { connectedAccount, connectedOpportunity, connectedResource, connectedSurvey, editedObjectId }
}

export function shouldBlockAutoSaveForUser (user: ReduxUser): boolean {
  const isTesting = sfOauthConfig.isTesting as boolean
  const isDebug = user.role.includes(DEBUG)
  return !isTesting && isDebug
}

/**
 * Checks complex Salesforce save results for error occurrences.
 * @param result The save result(s) to inspect.
 * @returns True if any error is found.
 */
export const checkIfSavingResultHasErrors = (result: any): boolean => {
  if (Array.isArray(result)) {
    return result.some((sub) => checkIfSavingResultHasErrors(sub))
  } else {
    if (result == null) {
      console.error(
        'No promise resolution configured or an unexpected error ocurred!'
      )
      return true
    }
    if (result.compositeResponse != null) {
      return result.compositeResponse.some((comp) => {
        if (comp.body == null) {
          return false
        } else {
          return comp.body.some((sub) => sub.success === false)
        }
      })
    }
    if ('isSuccess' in result) {
      if (result.outputValues != null && 'error' in result.outputValues) {
        return Boolean(result.outputValues.error)
      }
      return result.isSuccess === false
    }
    if ('success' in result) {
      return result.success === false
    }
    if ('hasErrors' in result) {
      return result.hasErrors
    }
    return false
  }
}
